import * as idEndpoints from './id';
import { online } from './online';

export const encoders = {
  id: {
    ...idEndpoints,
  },
  online,
};
